

































import { CartGroup, CartGroupList } from '@/models/cart/group/group'
import _ from 'lodash'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import NoItem from '@spa/components/organisms/cart/NoItem.vue'
import CartListItem from '@spa/components/pages/cart/components/cart-list/CartListItem.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { CookieService } from '@spa/services/cookie'

import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { User } from '@spa/store/modules/user/types'

@Component({
  components: {
    CartListItem,
    NoItem,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class CartList extends Vue {

  Status = Status

  status: Status = Status.Loading

  // override loading-mixin getter
  get isLoading (): boolean {
    return this.status === Status.Loading
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get groups(): CartGroupList {
    return this.$store.state.cart.groups
  }
  get groupsWithVisibleItem(): readonly CartGroup[] {
    return this.groups.filter(g => g.displayableItems.hasItem).list
  }

  get noItemExist(): boolean {
    return this.groups.items().isEmpty
  }

  get hasError(): boolean {
    return _.get(this.$store.state.cart, 'error.load')
  }

  async created () {
    await this.$store.dispatch('view/startLoading')

    await this.$store.dispatch('user/get')

    if (!CookieService.isGuest()) {
      await this.$store.dispatch('cart/load', { force: true })
    }
    if (this.hasError) {
      this.status = Status.Failed
    } else {
      this.status = Status.Completed

      EventBusForThirdParty.getInstance().publish('page-initialized', {
        url: window.location.href,
        initializedAt: CurrentTime.create().now,
        user: this.user,
      })
    }
  }
}
